// @flow
import React from "react";
import I18n from "../../i18n/I18n";
import styles from "./WareHouseCards.scss";
import { Dropdown, Badge, Button, Checkbox } from "../common";

type Props = {
  data: Array
};

const WareHouseCards = (props: Props) => {
  const {
    lang,
    notPref,
    processPref,
    notfSelected,
    processSelected,
    resetProcessForAll,
    toggleResetForAll,
    langSelected,
    onChange,
    onPrefSubmitWareHouse,
    index,
    postLoading
  } = props;
  const data = props.data || "";
  return (
    <div className={styles.wrapper}>
      <div className={styles.ctr}>
        <div className={styles.topBox}>
          {data.is_fbn !== "0" ? <Badge /> : ""}
          {data.is_active !== "0" ? (
            <span className={styles.badge}>
              {I18n.getText("settings.active", {}, "Active")}
            </span>
          ) : (
            ""
          )}
        </div>
        <div className={styles.box}>
          {data.contact_person ? (
            <div className={styles.eachSpec}>
              <p className={styles.header}>
                {I18n.getText("settings.warehouse-user", {}, "Name")}
              </p>
              <p className={styles.bold}>{data.contact_person}</p>
            </div>
          ) : (
            ""
          )}
          {data.contact ? (
            <div className={styles.eachSpec}>
              <p className={styles.header}>
                {I18n.getText("settings.warehouse-phone", {}, "Contact Number")}
              </p>
              <p className={styles.bold}>{data.contact}</p>
            </div>
          ) : (
            ""
          )}
          {data.email ? (
            <div className={styles.eachSpec}>
              <p className={styles.header}>
                {I18n.getText("settings.warehouse-email", {}, "email")}
              </p>
              <p className={styles.bold}>{data.email}</p>
            </div>
          ) : (
            ""
          )}
          {data.address ? (
            <div className={styles.eachSpec}>
              <p className={styles.header}>
                {I18n.getText("settings.warehouse-address", {}, "address")}
              </p>
              <p className={styles.bold}>{data.address}</p>
            </div>
          ) : (
            ""
          )}
          {data.code ? (
            <div className={styles.eachSpec}>
              <p className={styles.header}>
                {I18n.getText("settings.warehouse-code", {}, "Warehouse Code")}
              </p>
              <p className={styles.bold}>{data.code}</p>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className={styles.columnCtr}>
          <div className={styles.inputWrapper}>
            <p className={styles.inputTitle}>
              {I18n.getText(
                "settings.notf-pref",
                {},
                "Notification Preference"
              )}
            </p>
            <div className={styles.dropWrapper}>
              <Dropdown
                name={"pref"}
                value={notfSelected}
                options={notPref}
                placeholder={I18n.getText("settings.notf-pref")}
                onChange={e => onChange(e, "prefNotOptionWarehouse", index)}
              />
            </div>
          </div>
          {data.is_fbn === "0" ? (
            <div className={styles.inputWrapper}>
              <p className={styles.inputTitle}>
                {I18n.getText(
                  "settings.proc-pref",
                  {},
                  "Default Processing Time"
                )}
              </p>
              <div className={styles.dropWrapper}>
                <Dropdown
                  name={"pref"}
                  value={processSelected}
                  options={processPref}
                  placeholder={I18n.getText("settings.proc-pref")}
                  onChange={e => onChange(e, "prefProcOptionWarehouse", index)}
                />
                <Button
                  className={styles.flexer}
                  disabled={!processSelected}
                  onClick={() => toggleResetForAll(props.index)}
                >
                  <Checkbox
                    disabled={!processSelected}
                    checked={resetProcessForAll}
                    name={"jgsfg"}
                  />
                  {I18n.getText("settings.reset-for-all", {}, "Reset For All")}
                </Button>
              </div>
            </div>
          ) : (
            ""
          )}

          {false && (
            <div className={styles.inputWrapper}>
              <p className={styles.inputTitle}>
                {I18n.getText("settings.lang-pref", {}, "Language Preference")}
              </p>
              <div className={styles.dropWrapper}>
                <Dropdown
                  name={"lang"}
                  value={langSelected}
                  options={lang}
                  onChange={e => onChange(e, "prefLanguageWarehouse", index)}
                />
              </div>
            </div>
          )}
        </div>
        {/* <div className={styles.buttonWrapper}>
                    <Button
                        className={styles.ctaBtn}
                        variant="primary"
                        onClick={() => onPrefSubmitWareHouse(index)}
                    >
                        {postLoading ? (
                            <div className={styles.loader} />
                        ) : (
                            I18n.getText("settings.btn-submit", {}, "Submit")
                        )}
                    </Button>
                </div> */}
      </div>
    </div>
  );
};

export default WareHouseCards;



// WEBPACK FOOTER //
// ./src/components/settings/WareHouseCards.js